import { GLOSSARY } from '@features/glossary/subdomains/visitation';

type Definition = {
  title: string;
  definition: string;
  y: number;
};

export const DEFINITIONS: Definition[] = [
  {
    title: 'Transaction Size',
    definition: GLOSSARY.transactionSize.definition,
    y: 5.64,
  },
  {
    title: 'Transaction Rate',
    definition: GLOSSARY.transactionRate.definition,
    y: 5.9,
  },
  {
    title: 'Penetration Rate',
    definition: GLOSSARY.penetration.definition,
    y: 6.2,
  },
  { title: 'Sales Rate', definition: GLOSSARY.salesRate.definition, y: 6.46 },
];
